import { SVGProps } from 'react'

const FeesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="222"
    height="273"
    viewBox="0 0 222 273"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M179.392 266.892L181.116 268.904V268.904L179.392 266.892ZM214.96 236.405L213.235 234.393L214.96 236.405ZM216.638 72.1304C216.638 70.6668 217.824 69.4804 219.288 69.4804C220.751 69.4804 221.938 70.6668 221.938 72.1304H216.638ZM221.938 56.338C221.938 57.8015 220.751 58.988 219.288 58.988C217.824 58.988 216.638 57.8015 216.638 56.338H221.938ZM23.0588 243.023L20.4093 243.074L20.4088 243.049V243.023H23.0588ZM23.3415 257.721L25.991 257.67L23.3415 257.721ZM206.894 25.6382H35.4523V20.3382H206.894V25.6382ZM177.667 264.88L213.235 234.393L216.685 238.417L181.116 268.904L177.667 264.88ZM216.638 226.995V72.1304H221.938V226.995H216.638ZM216.638 56.338V35.3816H221.938V56.338H216.638ZM65.403 267.226H171.326V272.526H65.403V267.226ZM25.7088 35.3816V243.023H20.4088V35.3816H25.7088ZM25.7083 242.972L25.991 257.67L20.692 257.772L20.4093 243.074L25.7083 242.972ZM35.7326 267.226H65.403V272.526H35.7326V267.226ZM25.991 257.67C26.093 262.977 30.4245 267.226 35.7326 267.226V272.526C27.5371 272.526 20.8495 265.966 20.692 257.772L25.991 257.67ZM213.235 234.393C215.395 232.542 216.638 229.84 216.638 226.995H221.938C221.938 231.387 220.019 235.559 216.685 238.417L213.235 234.393ZM181.116 268.904C178.39 271.241 174.917 272.526 171.326 272.526V267.226C173.652 267.226 175.901 266.394 177.667 264.88L181.116 268.904ZM35.4523 25.6382C30.0711 25.6382 25.7088 30.0005 25.7088 35.3816H20.4088C20.4088 27.0734 27.144 20.3382 35.4523 20.3382V25.6382ZM206.894 20.3382C215.203 20.3382 221.938 27.0734 221.938 35.3816H216.638C216.638 30.0005 212.276 25.6382 206.894 25.6382V20.3382Z"
      fill="#0C393F"
    />
    <path
      d="M201.129 21.2228C201.129 22.6035 200.01 23.7228 198.629 23.7228C197.249 23.7228 196.129 22.6035 196.129 21.2228H201.129ZM2.40039 221.367L-0.0991473 221.415L-0.0996094 221.391V221.367H2.40039ZM2.68303 236.064L0.183493 236.113L2.68303 236.064ZM15.5684 245.72C16.9491 245.72 18.0684 246.839 18.0684 248.22C18.0684 249.6 16.9491 250.72 15.5684 250.72V245.72ZM186.236 4.83203H14.7938V-0.167969H186.236V4.83203ZM196.129 21.2228V14.7239H201.129V21.2228H196.129ZM4.90039 14.7254V221.367H-0.0996094V14.7254H4.90039ZM4.89993 221.319L5.18257 236.016L0.183493 236.113L-0.0991473 221.415L4.89993 221.319ZM15.0741 245.72H15.5684V250.72H15.0741V245.72ZM5.18257 236.016C5.2862 241.405 9.68431 245.72 15.0741 245.72V250.72C6.96036 250.72 0.339498 244.225 0.183493 236.113L5.18257 236.016ZM14.7938 4.83203C9.32983 4.83203 4.90039 9.26146 4.90039 14.7254H-0.0996094C-0.0996094 6.50005 6.5684 -0.167969 14.7938 -0.167969V4.83203ZM186.236 -0.167969C194.461 -0.167969 201.129 6.49809 201.129 14.7239H196.129C196.129 9.26033 191.7 4.83203 186.236 4.83203V-0.167969Z"
      fill="#0C393F"
    />
    <rect
      x="50.9436"
      y="141.758"
      width="111.352"
      height="8.26227"
      rx="4.13114"
      fill="#0C393F"
    />
    <rect
      x="50.9436"
      y="121.103"
      width="111.352"
      height="8.26227"
      rx="4.13114"
      fill="#0C393F"
    />
    <rect
      x="50.9436"
      y="161.381"
      width="83.6555"
      height="8.26227"
      rx="4.13114"
      fill="#0C393F"
    />
    <rect
      x="50.9436"
      y="182.037"
      width="83.6555"
      height="8.26227"
      rx="4.13114"
      fill="#0C393F"
    />
    <rect
      x="50.9436"
      y="205.791"
      width="61.9671"
      height="8.26227"
      rx="4.13114"
      fill="#FEC077"
    />
    <path
      d="M200.173 228.779C201.461 228.779 202.505 227.735 202.505 226.447C202.505 225.159 201.461 224.115 200.173 224.115L200.173 228.779ZM172.538 253.816C172.538 255.104 173.582 256.148 174.87 256.148C176.158 256.148 177.202 255.104 177.202 253.816L172.538 253.816ZM200.173 224.115L187.263 224.115L187.263 228.779L200.173 228.779L200.173 224.115ZM172.538 238.84L172.538 253.816L177.202 253.816L177.202 238.84L172.538 238.84ZM187.263 224.115C179.13 224.115 172.538 230.708 172.538 238.84L177.202 238.84C177.202 233.284 181.706 228.779 187.263 228.779L187.263 224.115Z"
      fill="#0C393F"
    />
    <path
      d="M66.9445 100.358C82.6303 100.358 95.3461 87.6426 95.3461 71.9569C95.3461 56.2711 82.6303 43.5553 66.9445 43.5553C51.2588 43.5553 38.543 56.2711 38.543 71.9569C38.543 87.6426 51.2588 100.358 66.9445 100.358Z"
      fill="#FEC077"
    />
    <path
      d="M72.1189 96.316C87.8046 96.316 100.52 83.6002 100.52 67.9145C100.52 52.2287 87.8046 39.5129 72.1189 39.5129C56.4331 39.5129 43.7173 52.2287 43.7173 67.9145C43.7173 83.6002 56.4331 96.316 72.1189 96.316Z"
      stroke="#0C393F"
      strokeWidth="4.13114"
    />
    <path
      d="M79.506 73.5774C79.506 75.4003 78.9292 76.9232 77.7754 78.1462C76.6448 79.3461 75.1103 80.0729 73.1721 80.3267V83.2687H70.3339V80.3267C68.0957 80.0498 66.3651 79.1845 65.1421 77.7308C63.9422 76.2771 63.3423 74.3273 63.3423 71.8814H67.3227C67.3227 73.4505 67.7149 74.685 68.4995 75.5849C69.284 76.4848 70.38 76.9348 71.7876 76.9348C72.9875 76.9348 73.9105 76.6579 74.5565 76.1041C75.2026 75.5272 75.5257 74.7196 75.5257 73.6813C75.5257 72.8967 75.2949 72.2391 74.8334 71.7084C74.3719 71.1777 73.5643 70.7046 72.4106 70.2893L68.6725 69.0779C67.1496 68.5472 65.9959 67.705 65.2113 66.5512C64.4268 65.3744 64.0345 63.99 64.0345 62.3978C64.0345 61.3364 64.2999 60.3442 64.8306 59.4212C65.3613 58.4751 66.0997 57.6906 67.0458 57.0676C68.0149 56.4446 69.1109 56.0638 70.3339 55.9254V52.8103H73.1721V56.0292C74.9488 56.3523 76.3564 57.1714 77.3947 58.4867C78.4331 59.7788 78.9522 61.3941 78.9522 63.3323H74.9719C74.9719 62.0171 74.6488 61.0133 74.0028 60.3211C73.3797 59.6058 72.4798 59.2481 71.303 59.2481C70.2878 59.2481 69.4917 59.5135 68.9148 60.0442C68.338 60.5518 68.0495 61.2556 68.0495 62.1555C68.0495 63.0554 68.2918 63.8169 68.7764 64.4399C69.284 65.0398 70.1724 65.559 71.4415 65.9974L75.3526 67.3819C76.7371 67.8665 77.7754 68.6395 78.4677 69.7009C79.1599 70.7623 79.506 72.0545 79.506 73.5774Z"
      fill="#0C393F"
    />
  </svg>
)

export default FeesIcon
